import { useEffect } from 'react';

const SITE = 'Eternally Blessed Library';

export function usePageMeta(title: string, description: string, canonicalPath?: string) {
  useEffect(() => {
    document.title = title === SITE ? SITE : `${title} — ${SITE}`;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) { meta = document.createElement('meta'); meta.name = 'description'; document.head.append(meta); }
    meta.content = description;
    if (canonicalPath) {
      let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
      if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.append(canonical); }
      canonical.href = `https://eternallyblessed-library.pages.dev${canonicalPath}`;
    }
  }, [canonicalPath, description, title]);
}
